<template>
  <div class="page-body">
    <b-card class="content-card">
      <template v-if="loading">
        <div class="h-100vh d-flex align-items-center justify-content-center">
          <BaseLoading />
        </div>
      </template>
      <div v-else>
        <div class="appbar-container">
          <h3 class="appbar-container__title">خزانه</h3>
          <b-button
            size="md"
            variant="success"
            @click="$bvModal.show('add-treasury')"
            class="mr-1"
          >
            افزودن به خزانه
          </b-button>
        </div>

        <div
          class="circle-chart-container"
          id="circle-chart-container"
        ></div>

        <base-input
          placeholder="جستجو..."
          v-model="filters.keywords"
        />
        <b-skeleton-table
          v-if="loading"
          :rows="5"
          :columns="5"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-table
          class="reward-table"
          v-else
          :items="filterResults"
          :fields="fields"
          empty-text="موردی یافت نشد"
          stacked="md"
          show-empty
          small
        >
          <template #cell(token)="row">
            <div class="text-center">
              <img
                :src="row.item.image"
                alt=""
                style="width: 32px"
              />
              <span class="font-weight-bold">
                {{ row.item.token }}
              </span>
            </div>
          </template>

          <template #cell(amount)="row">
            <div class="text-center">
              {{ row.item.amount }}
            </div>
          </template>

          <template #cell(usdtAmount)="row">
            <div class="text-center">
              {{ row.item.usdtAmount }}
            </div>
          </template>
          <template #cell(tomanAmount)="row">
            <div class="text-center">
              {{ addCommasToNumber(row.item.tomanAmount) }}
              تومان
            </div>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-modal
      hide-footer
      class="text-right"
      title="افزودن مقدار جدید به خزانه"
      id="add-treasury"
    >
      <div>
        <base-select
          v-model="increaseTreasuryData.token"
          :options="getCoins"
          label="انتخاب رمزارز"
        />

        <base-input
          label="مقدار"
          v-model="increaseTreasuryData.amount"
        />
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <b-button
          class="mt-3"
          variant="outline-danger"
          @click="$bvModal.hide('add-treasury')"
        >
          بستن
        </b-button>
        <base-button
          :disabled="
            !Boolean(increaseTreasuryData.token && increaseTreasuryData.amount)
          "
          :loading="increaseTreasuryData.loading"
          class="mt-2"
          type="success"
          @click="updateTreasury"
        >
          تایید
        </base-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  getCoinPrice,
  getCoinPrices,
  getTreasuryList,
  getUSDTPriceByToman,
  increaseTreasuryValue,
} from "@/httpservices/Treasury";
import Highcharts from "highcharts";
import BaseLoading from "@/components/BaseLoading";
import { BaseSelect, BaseButton } from "@/components";
import { addCommas } from "@persian-tools/persian-tools";
import NumberTools from "@/utils/NumberTools";

export default {
  name: "TreasuryList",

  components: {
    BaseLoading,
    BaseSelect,
    BaseButton,
  },

  data() {
    return {
      loading: true,
      items: [],
      fields: [
        {
          key: "token",
          label: "رمزارز",
          sortable: false,
          class: "text-center",
        },
        {
          key: "amount",
          label: "مقدار",
          sortable: false,
          class: "text-center",
        },
        {
          key: "tomanAmount",
          label: "ارزش تومانی",
          sortable: false,
          class: "text-center",
        },
        {
          key: "usdtAmount",
          label: "ارزش دلاری",
          sortable: false,
          class: "text-center",
        },
      ],
      filters: {
        keywords: "",
      },
      increaseTreasuryData: {
        modal: false,
        loading: false,
        amount: "",
        token: "",
      },
    };
  },

  computed: {
    filterResults() {
      if (this.filters.keywords) {
        return this.items.filter((item) =>
          item.token.includes(this.filters.keywords.toUpperCase())
        );
      }
      return this.items;
    },

    getCoins() {
      const data = this.$store.getters["getAssets"];
      data.unshift("IRT");
      return data;
    },
  },

  mounted() {
    this.$nextTick(async () => {
      await this.fetchData();
      await this.$store.dispatch("getAssets");
    });
  },

  methods: {
    addCommasToNumber(value) {
      if (value > 1) {
        return addCommas(Number(value).toFixed(0));
      }
      return value;
    },
    async fetchData() {
      this.loading = true;
      try {
        const usdtPriceByToman = (await getUSDTPriceByToman()).data.irtUsdt;
        const getAssetsWithPriceUSDT = (await getCoinPrices()).data;
        const res = (await getTreasuryList()).data;
        // const res = [
        //   { token: "USDT", amount: 16.386673341861506 },
        //   { token: "BTTC", amount: 200000000.0 },
        //   { token: "SHIB", amount: 20001000.0 },
        //   { token: "IRT", amount: 3900000.0 },
        // ];
        await Promise.all(
          res.map(async (item) => {
            const usdtAmountRow =
              [
                ...getAssetsWithPriceUSDT,
                {
                  symbol: "USDTUSDT",
                  price:
                    (res.find((i) => i.token === "USDT") || {}).amount || 0,
                },
                {
                  symbol: "IRTUSDT",
                  price: (res.find((i) => i.token === "IRT") || {}).amount || 0,
                },
              ].find((i) => i.symbol === item.token + "USDT") || {};

            console.log({ item });
            console.log({ usdtAmountRow });

            const usdtAmount =
              usdtAmountRow.symbol !== "USDTUSDT"
                ? Number(usdtAmountRow.price) * item.amount
                : Number(usdtAmountRow.price);

            return {
              ...item,
              image: `/img/coins/svg/${item.token.toLowerCase()}_.svg`,

              usdtAmount:
                item.token !== "IRT"
                  ? NumberTools.toFixedNoRounding(usdtAmount, 8)
                  : NumberTools.toFixedNoRounding(
                      item.amount / usdtPriceByToman,
                      8
                    ), // ارزش رمزارز بر اساس دلار

              tomanAmount:
                item.token !== "IRT"
                  ? Number(usdtAmount * usdtPriceByToman)
                  : item.amount, // ارزش رمزارز بر اساس تومان

              tomanAmountUnit:
                item.token !== "IRT"
                  ? Number(usdtAmount * usdtPriceByToman)
                  : item.amount, // ارزش هر واحد از رمزارز بر اساس تومان
            };
          })
        ).then((values) => (this.items = values));
      } catch (e) {
        console.log({ e });
      }
      this.loading = false;
      await this.showChart();
    },

    async showChart() {
      const usdtPriceByToman = Number(
        (await getUSDTPriceByToman()).data.irtUsdt
      ).toFixed(2);
      const data = this.items.map((item) => {
        return {
          name: item.token,
          y:
            item.token === "IRT"
              ? parseFloat(item.usdtAmount * (item.amount / usdtPriceByToman))
              : parseFloat(item.usdtAmount * item.amount),
          sliced: true,
          selected: true,
        };
      });
      console.log({ data });

      Highcharts.chart("circle-chart-container", {
        credits: {
          enabled: false,
        },
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        title: {
          text: "آمار رمزارز های موجود در خرانه",
          style: {
            fontFamily: "Shabnam",
          },
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
          },
        },
        series: [
          {
            name: "Token",
            colorByPoint: true,
            data,

            //   [
            //   {
            //     name: 'BTC',
            //     y: 61.41,
            //     sliced: true,
            //     selected: true
            //   },
            //   {
            //     name: 'IRT',
            //     y: 5,
            //     sliced: true,
            //     selected: true
            //   },
            // ]
          },
        ],
      });
    },

    async updateTreasury() {
      this.increaseTreasuryData.loading = true;
      try {
        await increaseTreasuryValue(this.increaseTreasuryData);
        await this.$swal.fire({
          position: "center",
          icon: "success",
          title: "با موفقیت اضافه شد.",
          showConfirmButton: false,
          timer: 1500,
        });
        this.$bvModal.hide("add-treasury");
        this.increaseTreasuryData.token = "";
        this.increaseTreasuryData.amount = "";
        await this.fetchData();
      } catch (e) {
        console.log(e);
      }
      this.increaseTreasuryData.loading = false;
    },
  },
};
</script>

<style lang="scss">
.modal-header .close {
  padding: 0;
  margin: 0;
}

.modal-body {
  text-align: right;
}

.reward-table td {
  height: 60px;
}

.reward-table td > div {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.appbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &__title {
    font-size: 24px;
  }
}

.reward-status-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: #ccc;
  padding: 5px;
  width: 100px;
  margin: auto;
}

.reward-status-chip.active {
  color: white;
  background-color: #2dce89;
}

.reward-status-chip.inactive {
  color: white;
  background-color: #f45656;
}

.filters-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 15px;
  background-color: #eee;
  border-radius: 5px;

  .title {
    display: flex;
    min-width: 150px;
  }

  .filters {
    width: 100%;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .actions {
    display: flex;
  }
}
</style>
